import mitt from 'mitt';

// Create a new emitter
export const emitter = mitt();

// Export that emitter
export default {
  install(app) {
    app.config.globalProperties.$mitt = emitter; // Add emitter to vue scope.
  },
};
